////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const kioskPricesManager = {
	postKioskPricesManager: (
		filters = {},
		queryParams = {
			page: '0',
			size: '250',
			sort: 'kiosk.labelToManufacturer',
			nameDir: 'asc',
			sort_2: 'itemDistributor.item.family.label',
			nameDir_2: 'asc',
			sort_3: 'itemDistributor.item.brand.label',
			nameDir_3: 'asc',
			sort_4: 'itemDistributor.item.label',
			nameDir_4: 'asc',
		}
	) => ({
		type: ActionsTypes.POST_KIOSK_PRICES_MANAGER,
		payload: {
			filters,
			queryParams,
		},
	}),
	postKioskPricesManagerSuccess: (data) => ({
		type: ActionsTypes.POST_KIOSK_PRICES_MANAGER_SUCCESS,
		payload: {
			data,
		},
	}),
	postKioskPricesManagerFailure: (error) => ({
		type: ActionsTypes.POST_KIOSK_PRICES_MANAGER_FAILURE,
		payload: {
			error,
		},
	}),
}

export default kioskPricesManager
